import React from 'react';
import t from 'prop-types';
import ClipLoader from 'react-spinners/ClipLoader';
import {colors} from '../styles';
import {Text} from '../atoms/Text';

const Loading = ({message}) => (
  <div style={{display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
    <Text style={{fontSize: '16px', color: colors.primary, marginBottom: '32px'}}>{message}</Text>
    <ClipLoader
      size={35}
      color={colors.primary}
      loading
    />
  </div>
);

Loading.propTypes = {
  message: t.string
};

export default Loading;
